import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function interactionTypeDataReducer(state = initialState.interactionTypeData, action) {
  switch (action.type) {
    case types.LOAD_INTERACTION_TYPE:
      return action.interactionTypeData;
    default:
      return state;
  }
}
